export function changepassword(req) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(req),
  };
  return fetch("api/changepassword", requestOptions).then((response) =>
    response.json()
  );
}
